export const BOLS = "BOLS";
export const BOLS_COUNT = "BOLS_COUNT";
